import { ref } from 'vue';

const getExpiredQualifications = () => {
    const expiredQualification_error = ref(null);
    const expiredQualifications = ref(null);
    const trainingResponse = ref(null);

    const loadExpiredQualifications = async ( monitor_others, view_locations) => {
        var params = [];
        params.push(['monitor_others',monitor_others]);
        params.push(['view_locations', view_locations]);
        
        try {
            let data = await fetch("/api/employeequalifications/open?" + new URLSearchParams(params));

            if (!data.ok) {
                throw Error("Can't load data");
            }
            //console.log('gets here', data);
            expiredQualifications.value = await data.json();
            
            //console.log("expiredQuals: " + JSON.stringfy(data));
            //console.log("expiredQuals: " + expiredQualifications.value);
        } catch (err) {
            expiredQualification_error.value = err.message;
        }
    };

    const endQualification = async (expiredQualification) => {
        //console.log('update');
        const id = expiredQualification.id;

        const tokenResponse = await fetch( '/sanctum/csrf-cookie', {
            method: 'GET',
            credentials: 'include'
          });
          const token = decodeURIComponent(getCookie('XSRF-TOKEN'));

        const requestOptions = {
            method: 'PUT',
            headers: {
                'X-XSRF-TOKEN': token,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(expiredQualification)
        };

        try {
            const response = await fetch('/api/employeequalifications/' + id, requestOptions);
            //console.log(requestOptions);
            if (!response.ok) {
                //console.log(response.status + ' - ' + response.statusText);
                expiredQualification_error.value = response.status + ' - ' + response.statusText;
               console.log(expiredQualification_error.value);
            }
            const data = await response.text();

        } catch (err) {
            expiredQualification_error.value = err.message;
            console.log( err.message);
        }
    };

    const assignTraining = async (expiredQualification) => {
        //console.log('assignTraining');
        const id = expiredQualification.id;

        const tokenResponse = await fetch( '/sanctum/csrf-cookie', {
            method: 'GET',
            credentials: 'include'
          });
          const token = decodeURIComponent(getCookie('XSRF-TOKEN'));

        const requestOptions = {
            method: 'PUT',
            headers: {
                'X-XSRF-TOKEN': token,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(expiredQualification)
        };

        try {
            const response = await fetch('/api/trainings/assignemployee/', requestOptions);
            if (!response.ok) {
                console.log(response.status + ' - ' + response.statusText);
                expiredQualification_error.value = response.status + ' - ' + response.statusText;
               console.log(expiredQualification_error.value);
            }
            const data = await response.json();
            trainingResponse.value = data;


        } catch (err) {
            expiredQualification_error.value = err.message;
            console.log( err.message);
        }
    };
    
    return { expiredQualifications, expiredQualification_error, loadExpiredQualifications, assignTraining, endQualification , trainingResponse};
}

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}

export default getExpiredQualifications;
